/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@eternal/Components/Headings/SectionTitle';
import MidContainer from '@eternal/Components/Layout/MidContainer';
import StructuredTextParser from '@eternal/Components/Utility/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/* Services */

/**
 *
 * @param {*} param0
 * @returns
 */
const AboutSadhguru = ({ sectionContent, region, lang }) => {
  const findElement = param =>
    sectionContent.find(el => el._modelApiKey === param);
  return (
    <Box width="100%" h="auto">
      <MidContainer w={1120}>
        <SectionTitle titleObj={findElement('section_title')} />
        <Flex flexWrap="wrap">
          {/* <SingleImage
            sectionContent={findElement('single_image')}
            width="477px"
            height="636px"
          /> */}
          <StructuredTextParser
            _before={{
              content: "''",
              display: 'inline-block',
              background: 'lightgray',
              width: { base: '100%', sm: '245px', xl: '477px' },
              height: { base: '384px', md: '328px', xl: '636px' },
              bgImage: {
                base: sectionContent[1].mobileImage?.url,
                md: sectionContent[1].image?.url,
              },
              float: 'left',
              bgSize: 'cover',
              bgPosition: 'center',
              marginRight: { sm: '5%' },
              marginBottom: { base: '22px', md: '12px' },
            }}
            sx={{
              p: {
                display: 'inline',
              },
            }}
            color="#040404"
            fontFamily="FedraSansStd-book"
            fontSize={{ base: '16px', md: '18px' }}
            lineHeight={{ base: '24px', md: '34px' }}
            str={render(findElement('structured_text').body)}
          />
        </Flex>
      </MidContainer>
    </Box>
  );
};

export default AboutSadhguru;
